<template>
    <div>

        <div class="row">
            <div class="col">
                <div class="page-bar">
                    <div class="page-title-breadcrumb">

                        <div class="row">
                            <div class="col">
                                <div class="abtg__bc-wrapper">


                                    <div class="home">
                                        <a class="parent-item" href="/dashboard">
                                            <i class="fas fa-home"></i></a>&nbsp;
                                    </div>

                                    <div class="arrow" style="padding-left:10px !important;"><img src="/img/bread-arrow.png"></div>

                                    <span v-for="(bl, index) in bread_list">
                                    <div class="link">
                                        <a class="parent-item" :href="bl.url"
                                           v-if="bl.url">{{bl.label}}</a>
                                        <a class="parent-item" @click="breadForceStep(bl.action)"
                                           v-else>{{bl.label}}</a>
                                    </div>
                                         <div class="arrow"><img src="/img/bread-arrow.png"></div>
                                        </span>


                                    <div class="link"><strong>{{bread_active.label}}</strong></div>
                                    <div class="arrow"><img src="/img/bread-arrow.png"></div>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import {mixin} from '../../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';
    import ModalDelete from '../../commons/modal_delete';

    const {mapFields} = createHelpers({
        getterType: 'auction/getField',
        mutationType: 'auction/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money, ModalDelete},
        data: function () {
            return {}
        },

        computed: {
            ...mapFields(['bread_list', 'bread_active', 'showDeleteModal']),
        },
        created: function () {
        },
        methods: {
            breadForceStep: function (whichStep) {
                this.$store.dispatch('mapping/breadForceStep', whichStep);
            }
        }
    }
</script>